import React, {forwardRef, useRef} from "react";
import "./styles.css";
import {formatBigName, getFileImageDisplay, popExtension} from "./constants";
import {
    formatAIDocumentColorCloud,
    formatAIDocumentStatus,
    formatMasterAIStatus, formatMasterAIStatusColorCloud,
} from "../../AI/aiHelper";

const File = forwardRef(({name, selected, onFileLeftClick, onContextMenu, onFileDoubleClick, primerPos, aiJSONResponses, aiStatus}, ref) => {
    const clickTimeout = useRef(null);

    const handleClick = (e) => {
        if (clickTimeout.current) return;

        clickTimeout.current = setTimeout(() => {
            clickTimeout.current = null;
            onFileLeftClick(e, name);
        }, 200); // Delay to differentiate single and double clicks
    }

    const handleDoubleClick = () => {
        if (clickTimeout.current) {
            clearTimeout(clickTimeout.current); // Cancel single click
            clickTimeout.current = null;
            onFileDoubleClick(name);
        }
    }

    const renderAIStatus = () => {
        const arr = [];
        let idx = 0;
        for (const obj of aiJSONResponses) {
            idx++;
            const statusString = formatAIDocumentStatus(obj.erp_status);
            arr.push(
                <div title={statusString}
                     style={{
                         backgroundColor: formatAIDocumentColorCloud(obj.erp_status),
                         padding: "2px",
                         textOverflow: "ellipsis",
                         whiteSpace: "nowrap",
                         overflow: "hidden",
                }}>
                    {aiJSONResponses.length > 1 ? <strong>Αρ. {idx}: </strong> : ""}
                    {statusString}
                </div>
            )
        }
        return arr;
    }

    const renderAIStar = () => {
        return (
            <div style={{
                position: "absolute",
                top: "0px",
                right: "0px",
                fontSize: "18px",
            }} title={"Με την βοήθεια του ✨ Primer AI"}>
                ✨
            </div>
        )
    }

    const aiStatusStyle = {
        display: "inline-block",
        marginTop: "5px",
        padding: 0,
        borderRadius: "6px",
        fontSize: "12px",
        lineHeight: "16px",
        width: "100%",
        overflow: "hidden",
    }

    return (
        <div
            className={`fileFolderStyle ${(selected && !primerPos) ? "fileFolderStyleSelected" : ""} ${primerPos ? "primerPosCustom" : ""}`}
            onClick={(e) => {
                if (!primerPos) {
                    handleClick(e);
                } else {
                    onFileDoubleClick(name);
                }
            }} style={{userSelect: "none"}}
            onDoubleClick={() => handleDoubleClick()}
            onContextMenu={(e) => {
                if (!primerPos) {
                    onContextMenu(e, "file", name)
                }
            }}
            ref={ref}
        >
            <div style={{position: "relative"}}>
                <img src={getFileImageDisplay(popExtension(name))} alt={"File"} style={{height: "56px", width: "56px"}}
                     draggable={false}/>
            </div>
            <div className={"mt-1"} style={{wordBreak: "break-all", fontSize: "12px"}}>
                {formatBigName(name)}
            </div>
            {(aiJSONResponses.length > 0 && aiStatus > 0) ? (
                <React.Fragment>
                    {renderAIStar()}
                    <div style={aiStatusStyle}>
                        {renderAIStatus()}
                    </div>
                </React.Fragment>
            ) : aiStatus ? (
                <React.Fragment>
                    {renderAIStar()}
                    <div style={aiStatusStyle}>
                        <div title={formatMasterAIStatus(aiStatus)}
                             style={{
                                 backgroundColor: formatMasterAIStatusColorCloud(aiStatus),
                                 padding: "2px",
                                 textOverflow: "ellipsis",
                                 whiteSpace: "nowrap",
                                 overflow: "hidden",
                             }}>
                            {formatMasterAIStatus(aiStatus)}
                        </div>
                    </div>
                </React.Fragment>
            ) : (
                <React.Fragment></React.Fragment>
            )}
        </div>
    )
})

export default File;
